import { Button, Modal } from "antd";
import { ShowToast, Severty } from "../helper/toast";
import {
  QuestionCircleOutlined,
  CheckCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import useRequest from "../hooks/useRequest";
import { method } from "lodash";
const { confirm } = Modal;

const ConfirmationBox = () => {
  const { request } = useRequest();

  const showConfirm = ({ record, path, onLoading, onSuccess, type }) => {
    setTimeout(() => {
      confirm({
        maskClosable: true,
        icon: <ExclamationCircleOutlined />,
        className: "tab_modal",
        cancelButtonProps: { color: "red" },
        content: (
          <p
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Are you sure you want change the status ?
          </p>
        ),
        onOk() {
          statusChange(record, path, onLoading, onSuccess, type, method);
          ShowToast("Status Changed Successfully", Severty.SUCCESS);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  const showConfirmDeleteAllNotifications = ({ onDelete }) => {
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: (
          <Button>Are you sure you want to delete all notifications?</Button>
        ),
        onOk() {
          onDelete();
        },
        onCancel() {},
        maskClosable: true, // This allows closing the modal by clicking outside
      });
    }, 5);
  };

  const statusChange = (record, path, onLoading, onSuccess, type) => {
    onLoading(true);
    let url = "";

    if (type !== null && type !== undefined) {
      url = path + "/" + type + "/" + record;
    } else {
      url = path + "/" + record;
    }

    request({
      url: url,
      method: "GET",
      onSuccess: (data) => {
        onSuccess();
        onLoading(false);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  return { showConfirm, showConfirmDeleteAllNotifications };
};

export default ConfirmationBox;
